module.exports = __webpack_public_path__ + "img/__icon_HAKÓWKA.d704249f.svg";